define('core/collections/PaginatedCollection',[
    'underscore',
    'backbone',
], function (
    _,
    Backbone
) {
    'use strict';

    /**
     * Augmented Backbone collection class that automatically records
     * and submits  the current cursor position when making fetches.
     *
     * See: the #more function, which paginates on the current cursor
     */
    var PaginatedCollection = Backbone.Collection.extend({

        PER_PAGE: 30, // Better backend performance to make less requests with higher limits

        initialize: function (_model, opts) {
            this.cid = _.uniqueId('collection');
            opts = opts || {};
            this.cursor = opts.cursor || {};
        },

        ensureFetched: _.memoize(function () {
            return this.fetch();
        }, function () {
            return this.cid;
        }),

        fetch: function (options) {
            options = options || {};
            options.data = _.defaults(options.data || {}, {
                cursor: options.cursor || '',
                limit: options.limit || this.PER_PAGE,
            });

            return Backbone.Collection.prototype.fetch.call(this, options);
        },

        hasPrev: function () {
            return this.cursor.hasPrev;
        },

        hasNext: function () {
            return this.cursor.hasNext;
        },

        next: function (options) {
            if (!this.cursor.hasNext)
                return void this.trigger('nodata');

            return this.fetch(_.extend({}, options, {
                add: true,
                remove: true,
                cursor: this.cursor.next,
            }));
        },

        prev: function (options) {
            if (!this.cursor.hasPrev)
                return void this.trigger('nodata');

            return this.fetch(_.extend({}, options, {
                add: true,
                remove: true,
                cursor: this.cursor.prev,
            }));
        },

        more: function (options) {
            var self = this;
            options = options || {};

            if (options.post ? !options.post.attributes.hasMore : !this.cursor.hasNext)
                return void self.trigger('nodata');

            // Accumulate models added to the collection, then fire a single
            // event that passes all added models.
            var added = [];
            function accum(model) {
                added.push(model);
            }

            var cursor;
            if (options.post) { // Was called in context of SubpaginatedPostCollection
                var postCursor = this.postCursors[options.post.id];
                cursor = postCursor && postCursor.cursor ? postCursor.cursor.next : '';
            } else {
                cursor = this.cursor.next;
            }

            this.on('add', accum);
            return this.fetch(_.extend({}, options, {
                add: true,
                remove: false,
                cursor: cursor,
                limit: this.PER_PAGE || this.perPage, // Two collections use this. One has PER_PAGE, the other perPage
                success: function () {
                    self.trigger('add:many', added, self, options);
                    self.off('add', accum);

                    if (options.success)
                        options.success.apply(this, arguments);
                },
            }));
        },

        parse: function (response) {
            // If `response` is an array of models, then we've already parsed the response, so do nothing.
            if (Array.isArray(response) && _.every(response, function (post) {
                return post instanceof Backbone.Model;
            }))
                return response;

            this.cursor = response.cursor || { hasNext: false };

            return response.response;
        },

        getLength: function () {
            return this.length;
        },
    });

    return PaginatedCollection;
});

